import { useState } from 'react';
import { Link } from 'react-router-dom';

import { Gate } from '../../../global/contexts/auth/auth';
import { IconEdit, IconGear } from '../../../common/icons';
import { formatDateOnly } from '../../../common/utils/date';
import { useUser } from '../contexts/users';
import { ROLE_LABEL } from '../utils/roles';
import UserForm from '../forms/user-form';
import RoleModal from '../forms/role-modal';

import '../../../common/styles/catalog.css';
import '../styles/users.css';

const STATUS_LABEL = { 2: 'Activo', 1: 'Inactivo', 0: 'Eliminado' };

function Field({ label, value }) {
    return (
        <div className="cat-detail__field">
            <span className="cat-detail__field-label">{label}</span>
            <span className="cat-detail__field-value">{value || <span className="cat-detail__empty">—</span>}</span>
        </div>
    );
}

// Detalle de un usuario staff + su bloque de PERMISOS (grants) — admin-users.md GET /:id.
export default function UserDetail({ userId }) {
    const { data: user, isLoading, error } = useUser(userId);
    const [form, setForm] = useState(false);
    const [roleOpen, setRoleOpen] = useState(false);

    if (isLoading) return <div className="cat-detail__state">Cargando usuario…</div>;
    if (error || !user) return <div className="cat-detail__state">Usuario no encontrado.</div>;

    const perms = user.permissions || {};
    const grants = perms.grants || [];

    return (
        <div className="cat-detail">
            <header className="cat-detail__header">
                <div>
                    <Link to="/admin/users" className="cat-detail__back">Usuarios</Link>
                    <div className="cat-detail__title-row">
                        <h1 className="cat-detail__title">{user.name || user.username || user.email}</h1>
                        <span className={`usr-role usr-role--${user.role}`}>{ROLE_LABEL[user.role] || user.role}</span>
                        <span className={`cat-badge cat-badge--${user.status}`}>{STATUS_LABEL[user.status] || '—'}</span>
                        {perms.superuser && <span className="usr-super">superusuario</span>}
                    </div>
                </div>
                <div className="cat-detail__actions">
                    <Gate domain="users" action="write">
                        <button type="button" className="cat-detail__edit" onClick={() => setForm(true)}><IconEdit /><span>Editar</span></button>
                    </Gate>
                    <Gate domain="users" action="admin">
                        <button type="button" className="cat-detail__edit" onClick={() => setRoleOpen(true)}><IconGear /><span>Cambiar rol</span></button>
                    </Gate>
                </div>
            </header>

            <section className="cat-detail__card">
                <h2 className="cat-detail__section-title">Información</h2>
                <div className="cat-detail__grid">
                    <Field label="Correo" value={user.email} />
                    <Field label="Usuario" value={user.username} />
                    <Field label="Rol" value={ROLE_LABEL[user.role] || user.role} />
                    <Field label="Estado" value={STATUS_LABEL[user.status]} />
                    <Field label="Últ. ingreso" value={user.last_login_at ? formatDateOnly(user.last_login_at) : 'nunca'} />
                    <Field label="Creado" value={formatDateOnly(user.created_at)} />
                </div>
            </section>

            <section className="cat-detail__card">
                <h2 className="cat-detail__section-title">Permisos {!perms.superuser && <span className="cat-overview__count">{grants.length}</span>}</h2>
                {perms.superuser ? (
                    <p className="usr-muted">Superusuario — acceso total (todos los dominios).</p>
                ) : !grants.length ? (
                    <p className="usr-muted">Sin permisos asignados.</p>
                ) : (
                    <div className="usr-grants">
                        {grants.map((g) => <span key={g} className="usr-grant">{g}</span>)}
                    </div>
                )}
            </section>

            {form && <UserForm user={user} onClose={() => setForm(false)} onSaved={() => setForm(false)} />}
            {roleOpen && <RoleModal user={user} onClose={() => setRoleOpen(false)} onSaved={() => setRoleOpen(false)} />}
        </div>
    );
}
